<template>
  <div class="pack-cart-wrapper">
    <!-- Main item -->
    <div class="item">
      <!-- Item left section with delete button and image -->
      <div class="item-left">
        <div class="delete" @click="removeFromCart">
          <img src="@/img/bin.svg" alt="Remove item" class="img" />
        </div>

        <div class="preview">
          <img :src="cartItem.item.img_url" alt="Pack image" class="img" />
          <div class="title small name">
            {{ cartItem.item.title }}
          </div>
        </div>

        <div class="title small name">
          {{ cartItem.item.title }}
        </div>
      </div>

      <!-- Item right section with quantity selector and price -->
      <div class="item-right">
        <div class="count">
          <div class="count__item" @click="decrementQuantity"></div>
          <input type="number" v-model="cartItem.count" readonly />
          <div class="count__item plus" @click="incrementQuantity"></div>
        </div>

        <div class="price">
          <span
            >{{ formattedPriceValue }}
            <span class="currency">{{ formattedCurrency }}</span></span
          >
        </div>
      </div>
    </div>

    <!-- Pack contents row - outside the main item -->
    <div class="pack-contents-row" v-if="hasItems">
      <div class="contents-label">Pack Contents:</div>
      <div class="contents-items">
        <div
          v-for="(item, index) in cartItem.item.items"
          :key="index"
          class="content-item"
        >
          <img :src="imgDomain + item.img_url" :alt="item.title" />
          <span class="quantity" v-if="item.quantity > 1"
            >{{ item.quantity }}x</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PackCartItem",
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
  },
  inject: ["getCurrency"],
  data() {
    return {
      imgDomain: "",
    };
  },
  computed: {
    hasItems() {
      return (
        this.cartItem.item &&
        this.cartItem.item.items &&
        this.cartItem.item.items.length > 0
      );
    },
    formattedPriceValue() {
      const price = this.cartItem.item.price;
      return price % 1 === 0
        ? Number(price).toFixed(0)
        : Number(price).toFixed(2);
    },
    formattedCurrency() {
      return this.getCurrency?.() || "EUR";
    },
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    incrementQuantity() {
      this.$emit(
        "increment",
        this.cartItem.item,
        this.cartItem.item_id,
        "pack"
      );
    },
    decrementQuantity() {
      this.$emit("decrement", this.cartItem, this.cartItem.item_id, "pack");
    },
    removeFromCart() {
      this.$emit("remove", this.cartItem.item, this.cartItem.item_id, "pack");
    },
  },
};
</script>

<style scoped>
.pack-cart-wrapper {
  overflow: hidden;
  border-radius: 6px;
  background: rgba(16, 15, 20, 0.5);
}

.cart-page .product-list .item {
  padding: 20px 40px 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  border-radius: initial;
  flex-wrap: wrap;
  background: initial;
}

.item-left {
  flex: 1;
  display: flex;
  align-items: center;
}

.item-right {
  display: flex;
  align-items: center;
}

.delete {
  width: 16px;
  min-width: 16px;
  height: 16px;
  margin-right: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.delete .img {
  width: 20px;
}

.cart-page .product-list .preview {
  position: relative;
  width: 138px;
  height: 94px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview .title.small.name {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 5px;
  text-align: center;
}

.cart-page .product-list .preview .img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
}

.title.small.name {
  padding-left: 34px;
  font-size: 14px;
  line-height: 22px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  color: #fff;
  text-align: left;
  flex: 1;
}

.pack-contents-row {
  padding: 8px 30px 8px 30px;
  display: flex;
  align-items: center;
  margin-top: 0;
  width: 100%;
  background: rgba(16, 15, 20, 0.5);
}

.contents-label {
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: #a7a7b1;
  min-width: 138px;
  margin-left: 48px;
}

.contents-items {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-left: 34px;
}

.content-item {
  width: 54px;
  height: 54px;
  background: #100f14;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.content-item img {
  width: 38px;
  height: 38px;
  object-fit: contain;
}

.content-item .quantity {
  position: absolute;
  bottom: 8px;
  right: 2px;
  color: white;
  font-size: 18px;
  font-weight: bold;
}

/* Mobile styles */
@media screen and (max-width: 768px) {
  .item {
    flex-wrap: wrap;
    padding-bottom: 14px;
  }

  .item > div {
    margin-bottom: 16px;
  }

  .delete {
    width: auto;
  }

  .title.small.name {
    padding-left: 16px;
    width: auto;
  }

  .price {
    width: auto;
    padding: 0 16px;
  }

  .preview {
    width: 100px;
    height: 70px;
  }

  .pack-contents-row {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
  }

  .contents-label {
    margin-bottom: 12px;
    margin-right: 0;
    margin-left: 0;
  }

  .contents-items {
    width: 100%;
    margin-left: 0;
  }
}
</style>
